<template>
  <Skeleton width="18rem" height="2rem" class="mb-2" />
  <Skeleton width="4rem" height="1.5rem" class="mb-5" />
  <Skeleton width="100%" class="mb-3" />
  <Skeleton width="100%" class="mb-3" />
  <Skeleton width="100%" class="mb-3" />
  <Skeleton width="100%" class="mb-3" />
  <Skeleton width="100%" class="mb-3" />
</template>
